import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle } from "react-feather";
import Confetti from "react-confetti";

const PaymentSuccess = () => {
    const location = useLocation();
    const sessionId = new URLSearchParams(location.search).get("session_id");
    const navigate = useNavigate();

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light p-4 position-relative">
            <Confetti numberOfPieces={200} recycle={false} />
            <div className="bg-white p-5 rounded-4 shadow-lg text-center w-50 border border-success">
                <div className="d-flex align-items-center justify-content-center mb-4">
                    <CheckCircle size={80} className="text-success" />
                </div>
                <h2 className="fs-1 fw-bold text-dark">Payment Successful!</h2>
                <p className="text-secondary mt-3">Thank you for your purchase. Your payment has been processed successfully.</p>
                {sessionId && (
                    <div className="mt-4 text-dark fw-semibold fs-5 border p-3 rounded bg-light mt-5 d-flex align-items-center  justify-content-center gap-3">
                        Transaction ID: <span
                            className="text-success m-0"
                            style={{
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                display: 'inline-block',
                                maxWidth: '200px', 
                            }}
                        >
                            {sessionId}
                        </span>

                    </div>
                )}
                <button
                    className="mt-4 px-5 py-3 btn btn-success fw-semibold shadow-sm rounded-pill fs-5"
                    onClick={() => navigate("/")}
                >
                    Return to Home
                </button>
            </div>
        </div>
    );
};

export default PaymentSuccess;
